.multi-package-button {
  display: flex;
  align-items: center;
}

.multi-package-button-content {
  align-items: center;

  .icon {
    width: 12px;
    height: 12px;
  }
}
